import { takeLatest, call, put } from 'redux-saga/effects';
import { AssetAdminApi } from 'api';
import { apiCallStatus, NOTIFICATION_TYPES } from 'helpers/constants';
import logger from 'helpers/logger';
import { actionTypes } from './constants';
import { enableDisableDriveAction } from './actions';
import { actionTypes as GatewayDetailsActionTypes } from '../../../constants';
import { notify } from 'sharedComponents/GeneralNotification';
import { translate } from 'helpers/translateHelper';

function* enableDisableDrive({ assetId, isDisabled, gatewayID }) {
    yield put(enableDisableDriveAction(apiCallStatus.LOADING));
    try {
        const response = yield call(AssetAdminApi.enableDisableDrive, assetId, isDisabled);

        if (response?.errorMessage) {
            yield put(enableDisableDriveAction(apiCallStatus.ERROR, response));
            notify(response?.errorMessage, NOTIFICATION_TYPES.ERROR, true);
            return;
        }

        yield put(enableDisableDriveAction(apiCallStatus.SUCCESS, response));

        const successMessage = response?.isDisabled
            ? translate('ABB.Powertrain.Frontend.drivesDataDeactivatedSuccessMessage')
            : translate('ABB.Powertrain.Frontend.drivesDataActivatedSuccessMessage');

        notify(successMessage, NOTIFICATION_TYPES.SUCCESS);

        yield put({
            type: GatewayDetailsActionTypes.GET_GATEWAY_CONNECTED_ASSETS,
            payload: { gatewayID: gatewayID }
        });

        logger.debug('Activate/Deactivate Asset successfully triggered for page ');
    } catch (err) {
        yield put(enableDisableDriveAction(apiCallStatus.ERROR, [], err));
        notify(err?.message, NOTIFICATION_TYPES.ERROR, true);
    }
}
export function* enableDisableDriveWatchers() {
    yield takeLatest(actionTypes.ENABLE_DISABLE_DRIVE, enableDisableDrive);
}
